import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { formatDate } from '../../../utils/financialCalculations';

const ClaimantInformation = ({ reportData }) => {
    const claimant = {
        name: reportData.claimantName || reportData.fullName || 'N/A',
        dateOfBirth: formatDate(reportData.claimantDOB || reportData.dateOfBirth),
        incidentDate: formatDate(reportData.incidentDate),
        gender: reportData.claimantGender || reportData.gender || 'N/A',
        educationLevel: reportData.claimantEducation || reportData.educationLevel || 'N/A',
        employmentStatus: reportData.claimantEmploymentStatus || reportData.employmentStatus || 'N/A',
        state: reportData.claimantState || reportData.provinceOrState || 'N/A',
    };

    return (
        <>
            <Box className="report-section" sx={{ mb: 2 }}>
                <Typography variant="h6" gutterBottom>Claimant Information</Typography>
                <Typography sx={{ mb: 0.5 }}><strong>Prepared for:</strong> {claimant.name}</Typography>
                <Typography sx={{ mb: 0.5 }}><strong>Date of Birth:</strong> {claimant.dateOfBirth}</Typography>
                <Typography sx={{ mb: 0.5 }}><strong>Incident Date:</strong> {claimant.incidentDate}</Typography>
                <Typography sx={{ mb: 0.5 }}><strong>Gender:</strong> {claimant.gender}</Typography>
                <Typography sx={{ mb: 0.5 }}><strong>Education:</strong> {claimant.educationLevel}</Typography>
                <Typography sx={{ mb: 0.5 }}><strong>Employment Status:</strong> {claimant.employmentStatus}</Typography>
                <Typography sx={{ mb: 0.5 }}><strong>State:</strong> {claimant.state}</Typography>
            </Box>
            <Divider sx={{ my: 2 }} />
        </>
    );
};

ClaimantInformation.addPdfContent = (pdf, reportData, y) => {
    const claimant = {
        name: reportData.claimantName || reportData.fullName || 'N/A',
        dateOfBirth: formatDate(reportData.claimantDOB || reportData.dateOfBirth),
        incidentDate: formatDate(reportData.incidentDate),
        gender: reportData.claimantGender || reportData.gender || 'N/A',
        educationLevel: reportData.claimantEducation || reportData.educationLevel || 'N/A',
        employmentStatus: reportData.claimantEmploymentStatus || reportData.employmentStatus || 'N/A',
        state: reportData.claimantState || reportData.provinceOrState || 'N/A',
    };

    pdf.setFontSize(12);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Claimant Information', 15, y);
    y += 7;
    pdf.setFont('helvetica', 'normal');
    const claimantLines = [
        `Prepared for: ${claimant.name}`,
        `Date of Birth: ${claimant.dateOfBirth}`,
        `Incident Date: ${claimant.incidentDate}`,
        `Gender: ${claimant.gender}`,
        `Education: ${claimant.educationLevel}`,
        `Employment Status: ${claimant.employmentStatus}`,
        `State: ${claimant.state}`,
    ];
    claimantLines.forEach(line => {
        const wrapped = pdf.splitTextToSize(line, 180);
        pdf.text(wrapped, 15, y);
        y += 6 * wrapped.length;
    });
    y += 2;
    pdf.setDrawColor(200);
    pdf.line(15, y, 195, y);
    y += 6;
    return y;
};

export default ClaimantInformation;